import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { CreatePollPage } from './pages/CreatePollPage';
import { CreateSchedulePage } from './pages/CreateSchedulePage';
import { PollVotingPage } from './pages/PollVotingPage';
import { PollResultsPage } from './pages/PollResultsPage';
import { NotFoundPage } from './pages/NotFoundPage';

export const App: React.FC = () => {
  return (
    <Router>
      <LanguageProvider>
        <AuthProvider>
          <ToastProvider>
            <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/create" element={<CreatePollPage />} />
                <Route path="/create-schedule" element={<CreateSchedulePage />} />
                <Route path="/poll/:pollId" element={<PollVotingPage />} />
                <Route path="/poll/:pollId/results" element={<PollResultsPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </ToastProvider>
      </AuthProvider>
    </LanguageProvider>
  </Router>
);
};

export default App;
